import React from "react";

export default function BirthChildFrame3({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1500 1500"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>{".cls-3bir1{fill:#194faf}.cls-3bir2{fill:#5a8bf9}"}</style>
        </defs>
        <path
          d="M1097.5 1269.44c64.46 0 116.72-52.26 116.72-116.72V480.19c0-11.33 8.99-20.62 20.31-20.99 11.86-.39 21.69 9.12 21.69 20.99v672.53c0 87.66-71.06 158.72-158.72 158.72l-90.45.13c-11.6 0-21-9.4-21-21s9.4-21 21-21l90.45-.13ZM243.78 457.72c0-87.66 71.06-158.72 158.72-158.72h449.66c11.47 0 20.81 9.2 21 20.66.19 11.73-9.27 21.34-21 21.34H402.5c-64.46 0-116.72 52.26-116.72 116.72v673.03c0 11.6-9.4 21-21 21s-21-9.4-21-21V457.72Z"
          className="cls-3bir2"
        />
        <path
          d="M1087.39 353.11c-4.9 13.34-19.7 10.21-31.14 28.08-7.9 12.35-13.44 33.56-1.51 47.63 12.39 14.61 36.6 13.27 40.84 12.96 36.13-2.66 57.85-36.56 64.99-47.7 4.73-7.39 41.24-64.36 9.58-105.26-15.58-20.13-49.06-38.16-74.56-28.08-13.54 5.35-24.7 18.58-26.88 32.75-4.09 26.56 25.94 39.88 18.69 59.62Z"
          className="cls-3bir1"
        />
        <ellipse
          cx={1090.28}
          cy={230.54}
          className="cls-3bir1"
          rx={21.47}
          ry={23.26}
          transform="rotate(-16.85 1090.472 230.545)"
        />
        <ellipse
          cx={1133.9}
          cy={239.34}
          className="cls-3bir1"
          rx={18.15}
          ry={16.49}
          transform="rotate(-63.66 1133.886 239.344)"
        />
        <ellipse
          cx={1165.9}
          cy={256.01}
          className="cls-3bir1"
          rx={14.96}
          ry={13.59}
          transform="rotate(-63.66 1165.884 256.015)"
        />
        <ellipse
          cx={1186.8}
          cy={279.42}
          className="cls-3bir1"
          rx={13.42}
          ry={11.22}
          transform="rotate(-36.43 1186.674 279.43)"
        />
        <ellipse
          cx={1197.69}
          cy={303.56}
          className="cls-3bir1"
          rx={11.75}
          ry={9.31}
          transform="rotate(-23.35 1197.809 303.571)"
        />
        <path
          d="M1005.19 279.74c4.9 13.34 19.7 10.21 31.14 28.08 7.9 12.35 13.44 33.56 1.51 47.63-12.39 14.61-36.6 13.27-40.84 12.96-36.13-2.66-57.85-36.56-64.99-47.7-4.73-7.39-41.24-64.36-9.58-105.26 15.58-20.13 49.06-38.16 74.56-28.08 13.54 5.35 24.7 18.58 26.88 32.75 4.09 26.56-25.94 39.88-18.69 59.62Z"
          className="cls-3bir1"
        />
        <ellipse
          cx={1002.3}
          cy={157.17}
          className="cls-3bir1"
          rx={23.26}
          ry={21.47}
          transform="rotate(-73.15 1002.265 157.19)"
        />
        <ellipse
          cx={958.69}
          cy={165.97}
          className="cls-3bir1"
          rx={16.49}
          ry={18.15}
          transform="rotate(-26.34 958.716 165.962)"
        />
        <ellipse
          cx={926.69}
          cy={182.64}
          className="cls-3bir1"
          rx={13.59}
          ry={14.96}
          transform="rotate(-26.34 926.71 182.633)"
        />
        <ellipse
          cx={905.78}
          cy={206.05}
          className="cls-3bir1"
          rx={11.22}
          ry={13.42}
          transform="rotate(-53.57 905.847 206.03)"
        />
        <ellipse
          cx={894.89}
          cy={230.19}
          className="cls-3bir1"
          rx={9.31}
          ry={11.75}
          transform="rotate(-66.65 894.859 230.197)"
        />
        <path
          d="M320.73 1331.06c-5.92 0-13.44-1.1-22.55-3.29-5.71 1.54-11.03 2.3-15.96 2.3s-7.79-.16-8.56-.49c.77-6.58 4.03-22.79 9.79-48.63 5.76-25.84 8.64-42.05 8.64-48.63 0-1.32-.71-3.07-2.14-5.27-1.43-2.19-2.86-4.06-4.28-5.6l-2.14-2.3.49-2.47c14.37-2.96 29.84-4.44 46.41-4.44 9.11 0 16.59 2.17 22.47 6.5 5.87 4.34 8.8 10.4 8.8 18.19 0 15.03-9.16 25.46-27.49 31.27 7.35.88 13.52 3.65 18.52 8.31 4.99 4.66 7.49 11.22 7.49 19.67 0 10.31-3.73 18.71-11.19 25.18-7.46 6.48-16.9 9.71-28.31 9.71Zm-2.96-58.43c-3.07 0-5.82.28-8.23.82-4.72 20.85-7.74 35.39-9.05 43.62 2.74 1.87 7.05 2.8 12.92 2.8s10.89-2.33 15.06-6.99 6.25-11.38 6.25-20.16c0-13.39-5.65-20.08-16.95-20.08Zm9.22-50.2c-4.17 0-6.64.39-7.41 1.15-1.54 9.87-4.06 22.82-7.57 38.84 4.39 0 7.46-.27 9.22-.82 1.75-.55 3.32-1.26 4.69-2.14 1.37-.88 2.93-2.25 4.69-4.11 3.84-4.06 5.76-10.56 5.76-19.5s-3.13-13.41-9.38-13.41ZM417.67 1260.94c.22-.22.82-1.65 1.81-4.28 5.16 0 12.07 1.54 20.74 4.61-2.74 9.11-4.94 18.63-6.58 28.55-1.65 9.93-2.47 17.01-2.47 21.23s.44 6.34 1.32 6.34c.66 0 3.07-1.04 7.24-3.13l1.98-.99 2.96 5.76c-.99.88-2.28 1.97-3.87 3.29-1.59 1.32-4.58 3.1-8.97 5.35-4.39 2.25-8.34 3.37-11.85 3.37-6.8 0-10.75-3.07-11.85-9.22-7.02 6.15-13.36 9.22-19.01 9.22s-10.43-2.19-14.32-6.58c-3.9-4.39-5.84-11.3-5.84-20.74 0-14.7 3.02-26.3 9.05-34.81 6.03-8.5 13.33-12.76 21.89-12.76 6.14 0 12.07 1.59 17.77 4.77Zm-18.76 56.12c2.63 0 5.6-1.04 8.89-3.13.77-15.47 3.35-30.78 7.73-45.92-3.29-1.42-6.09-2.14-8.39-2.14-3.95 0-7.32 3.87-10.12 11.6-2.8 7.74-4.2 16.27-4.2 25.59s2.03 13.99 6.09 13.99ZM490.25 1214.2c0 8.34-2.8 24.69-8.39 49.05 6.58-4.72 12.53-7.08 17.86-7.08s9.88 2.22 13.66 6.67c3.79 4.44 5.68 11.22 5.68 20.33 0 15.25-2.99 27.05-8.97 35.39s-13.25 12.51-21.81 12.51c-3.18 0-6.39-.39-9.63-1.15-3.24-.77-5.68-1.59-7.32-2.47l-2.47-1.15c-7.02 2.41-13.88 3.62-20.57 3.62-.66-.55-.99-3.21-.99-7.98s3.07-20.57 9.22-47.4c6.14-26.83 9.22-45.18 9.22-55.05 0-1.75-.28-4-.82-6.75 8.56-2.96 16.73-4.44 24.52-4.44.55 1.54.82 3.51.82 5.93Zm-1.48 55.96c-2.09 0-5.21.99-9.38 2.96-5.05 21.29-7.79 36.54-8.23 45.75 3.29 1.43 6.42 2.14 9.38 2.14 4.17 0 7.65-3.84 10.45-11.52 2.8-7.68 4.2-16.15 4.2-25.43s-2.14-13.91-6.42-13.91ZM541.1 1329.74c-9.22 0-13.83-5.05-13.83-15.14 0-2.41 1.1-9.38 3.29-20.9 2.19-11.52 3.29-21.12 3.29-28.8 0-1.65-.22-3.18-.66-4.61 5.92-2.3 14.04-3.46 24.36-3.46.55 1.54.82 4.17.82 7.9s-1.21 11.47-3.62 23.21-3.62 19.31-3.62 22.71 1.42 5.1 4.28 5.1c3.4 0 7.51-1.7 12.34-5.1.55-6.47 2.74-23.54 6.58-51.19 3.84-1.54 10.75-2.3 20.74-2.3h3.13c-2.09 8.23-4.12 20.08-6.09 35.55-1.98 15.47-3.57 26.22-4.77 32.26-2.3 12.07-6.56 21.92-12.75 29.54-6.2 7.62-14.29 11.44-24.28 11.44-3.95 0-7.55-1.04-10.78-3.13-3.24-2.09-4.86-4.77-4.86-8.06 0-4.39 2.69-8.39 8.06-12.01 5.37-3.62 12.62-6.42 21.73-8.39.99-4.83 1.75-9.49 2.3-13.99-8.89 6.25-17.45 9.38-25.67 9.38Zm7.98 17.12c-3.68 2.19-5.51 4.33-5.51 6.42s1.18 3.13 3.54 3.13 5.02-1.13 7.98-3.37c2.96-2.25 5.43-5.9 7.41-10.94-5.27.99-9.74 2.58-13.41 4.77ZM684.12 1331.06c-5.92 0-13.44-1.1-22.55-3.29-5.71 1.54-11.03 2.3-15.96 2.3s-7.79-.16-8.56-.49c.77-6.58 4.03-22.79 9.79-48.63 5.76-25.84 8.64-42.05 8.64-48.63 0-1.32-.71-3.07-2.14-5.27-1.43-2.19-2.86-4.06-4.28-5.6l-2.14-2.3.49-2.47c14.37-2.96 29.84-4.44 46.41-4.44 9.11 0 16.59 2.17 22.47 6.5 5.87 4.34 8.8 10.4 8.8 18.19 0 15.03-9.16 25.46-27.49 31.27 7.35.88 13.52 3.65 18.52 8.31 4.99 4.66 7.49 11.22 7.49 19.67 0 10.31-3.73 18.71-11.19 25.18-7.46 6.48-16.9 9.71-28.31 9.71Zm-2.96-58.43c-3.07 0-5.82.28-8.23.82-4.72 20.85-7.74 35.39-9.05 43.62 2.74 1.87 7.05 2.8 12.92 2.8s10.89-2.33 15.06-6.99 6.25-11.38 6.25-20.16c0-13.39-5.65-20.08-16.95-20.08Zm9.22-50.2c-4.17 0-6.64.39-7.41 1.15-1.54 9.87-4.06 22.82-7.57 38.84 4.39 0 7.46-.27 9.22-.82 1.75-.55 3.32-1.26 4.69-2.14 1.37-.88 2.93-2.25 4.69-4.11 3.84-4.06 5.76-10.56 5.76-19.5s-3.13-13.41-9.38-13.41ZM755.06 1331.06c-7.57 0-13.5-2.66-17.77-7.98-4.28-5.32-6.42-12.76-6.42-22.3 0-12.18 3.26-22.66 9.79-31.44 6.53-8.78 15.55-13.17 27.07-13.17l5.92.33c1.87-.99 3.95-1.48 6.25-1.48 8.67 0 13 8.18 13 24.52 4.5-.22 9.05-.82 13.66-1.81l2.63-.66.99 6.42c-3.62 1.54-8.5 2.91-14.65 4.11l-3.29.66c-2.09 11.52-6.31 21.53-12.67 30.04-6.36 8.5-14.54 12.76-24.52 12.76Zm8.89-14.15c4.61 0 8.75-2.96 12.43-8.89 3.67-5.92 6.23-12.18 7.65-18.76-11.74 0-17.61-4.39-17.61-13.17 0-3.51.71-6.8 2.14-9.87l.82-1.65c-.44-.22-.99-.33-1.65-.33s-1.15.11-1.48.33c-2.74 1.76-5.32 5.87-7.74 12.34-2.41 6.48-3.62 13.88-3.62 22.22 0 11.85 3.02 17.78 9.05 17.78Z"
          className="cls-3bir1"
        />
        <path
          d="M813.81 1329.74c-9.22 0-13.83-5.05-13.83-15.14 0-2.41 1.1-9.38 3.29-20.9 2.19-11.52 3.29-21.12 3.29-28.8 0-1.65-.22-3.18-.66-4.61 5.92-2.3 14.04-3.46 24.36-3.46.55 1.54.82 4.17.82 7.9s-1.21 11.47-3.62 23.21-3.62 19.31-3.62 22.71 1.42 5.1 4.28 5.1c3.4 0 7.51-1.7 12.34-5.1.55-6.47 2.74-23.54 6.58-51.19 3.84-1.54 10.75-2.3 20.74-2.3h3.13c-2.09 8.23-4.12 20.08-6.09 35.55-1.98 15.47-3.57 26.22-4.77 32.26-2.3 12.07-6.56 21.92-12.75 29.54-6.2 7.62-14.29 11.44-24.28 11.44-3.95 0-7.55-1.04-10.78-3.13-3.24-2.09-4.86-4.77-4.86-8.06 0-4.39 2.69-8.39 8.06-12.01 5.37-3.62 12.62-6.42 21.73-8.39.99-4.83 1.75-9.49 2.3-13.99-8.89 6.25-17.45 9.38-25.67 9.38Zm7.98 17.12c-3.68 2.19-5.51 4.33-5.51 6.42s1.18 3.13 3.54 3.13 5.02-1.13 7.98-3.37c2.96-2.25 5.43-5.9 7.41-10.94-5.27.99-9.74 2.58-13.41 4.77ZM878 1327.85c-2.2-2.14-3.29-5.02-3.29-8.64s1.51-6.8 4.53-9.55c3.02-2.74 6.5-4.11 10.45-4.11s7.02 1.1 9.22 3.29c2.19 2.2 3.29 5.08 3.29 8.64s-1.56 6.72-4.69 9.46c-3.13 2.74-6.61 4.11-10.45 4.11s-6.86-1.07-9.05-3.21Zm39.01-108.05c0 10.86-3.57 27.92-10.7 51.19-.55 1.87-1.56 5.24-3.04 10.12-1.48 4.88-2.61 8.64-3.37 11.27-2.96.99-5.57 1.48-7.82 1.48s-4.25-.11-6.01-.33c3.95-23.81 5.92-44.82 5.92-63.04l-.99-13.83c9.32-2.96 17.66-4.44 25.02-4.44.66.99.99 3.51.99 7.57Z"
          className="cls-3bir1"
        />
        {children}
      </g>
    </svg>
  );
}
